import React from 'react';
import { Grid, List } from 'semantic-ui-react';
import { MenuCategoryPropType } from '../../../../../../services/proptypes';
import { MenuConsumer } from '../../../../FoodMenu.context';
import MenuUtil from '../../../../utils/menu';
import ItemContainer from '../../item/ItemContainer';
import CategoryHeader from '../components/CategoryHeader/CategoryHeader';
var defaultProps = {
  scheduleCategories: []
};
var CategoryColumn = function CategoryColumn(_ref) {
  var category = _ref.category,
    scheduleCategories = _ref.scheduleCategories;
  return /*#__PURE__*/React.createElement(MenuConsumer, null, function (_ref2) {
    var items = _ref2.items;
    var itemIds = category.items,
      name = category.name;
    var categoryItems = MenuUtil.getCategoryItems(itemIds, items);
    return /*#__PURE__*/React.createElement(Grid.Column, {
      id: name,
      className: "category-container"
    }, /*#__PURE__*/React.createElement(CategoryHeader, {
      category: category,
      scheduleCategories: scheduleCategories
    }), /*#__PURE__*/React.createElement("div", {
      className: "category-container-content",
      style: {
        padding: '0.75rem 2.5% 0 2.5%'
      }
    }, /*#__PURE__*/React.createElement(List, null, categoryItems.map(function (_ref3) {
      var _id = _ref3._id;
      return /*#__PURE__*/React.createElement(ItemContainer, {
        key: _id,
        itemId: _id,
        showDescription: false,
        showModifierSets: false
      });
    }))));
  });
};
CategoryColumn.defaultProps = defaultProps;
export default CategoryColumn;